<div class="logo-and-beta-label">
  <a href="/">
    <img ngSrc="/assets/img/logos/Original.svg" alt="Cykubed app" height="90" width="450" priority>
  </a>
</div>
<p class="tagline">Cypress / Playwright test automation using Kubernetes</p>
